export function getSidebarConfigurations(perms, customerId) {
  let permissions = {};
  for (const key in perms) {
    if (perms[key].canReach) {
      permissions[key] = perms[key];
    }
  }
  const items = [
    // ---- Main Menu Start ----
    {
      // permission: permissions.dash_c,
      permission: false,
      label: "Ana Menü",
      submenuOpen: true,
      showSubRoute: true,
      submenuHdr: "board",
      submenuItems: [
        {
          permission: permissions.dash_c,
          label: "Paneller",
          icon: "ti ti-layout-2",
          submenu: true,
          showSubRoute: true,
          submenuItems: [
            {
              permission: true,
              label: "Müşteri Paneli",
              link: "/dashboard/customer",
              showSubRoute: false,
            },
          ],
        },
      ],
    },
    // ---- Main Menu end ----

    {
      permission: permissions.blog || permissions.contact_form,
      label: "Platform",
      submenuOpen: true,
      showSubRoute: true,
      submenuHdr: "Inventory",
      submenuItems: [
        {
          permission: permissions.blog,
          label: "Blog",
          link: "/",
          icon: "bi bi-pencil-square",
          showSubRoute: false,
          submenu: false,
        },
        {
          permission: permissions.contact_form,
          label: "İletişim Formları",
          link: "/contact-forms",
          icon: "ti ti-file-invoice",
          showSubRoute: false,
          submenu: false,
        },
        {
          permission: permissions.settings,
          label: "Müşteri Yorumları",
          icon: "bi bi-chat-quote",
          link: "/customer-comments",
          submenu: false,
          showSubRoute: false,
        },
        {
          permission: permissions.settings,
          label: "SSS (FAQ)",
          icon: "bi bi-question-circle",
          link: "/faqs",
          submenu: false,
          showSubRoute: false,
        },
        // {
        //   permission: permissions.settings,
        //   label: "Ekibimiz",
        //   icon: "bi bi-people",
        //   link: "/team",
        //   submenu: false,
        //   showSubRoute: false,
        // },
        // {
        //   permission: permissions.attribute,
        //   label: "Tanımlamalar",
        //   icon: "ti ti-brand-airtable",
        //   submenu: true,
        //   showSubRoute: true,
        //   submenuItems: [
        //     {
        //       permission: true,
        //       label: "Duyuru Tipleri",
        //       link: "/attributes/announce-types",
        //       showSubRoute: false,
        //     },
        //   ],
        // },
      ],
    },

    {
      permission: true,
      label: "Site Yönetimi",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          permission: permissions.page,
          label: "Sayfalar",
          icon: "bi bi-file-earmark-text",
          link: "/pages",
          submenu: false,
          showSubRoute: false,
        },
        {
          permission: permissions.page,
          label: "Sayfa Grupları",
          icon: "bi bi-folder",
          link: "/page-groups",
          submenu: false,
          showSubRoute: false,
        },
        // {
        //   permission: permissions.settings,
        //   label: "Menü Yönetimi",
        //   icon: "bi bi-newspaper",
        //   link: "/navigation",
        //   submenu: false,
        //   showSubRoute: false,
        // },
        {
          permission: permissions.event,
          label: "Etkinlikler",
          icon: "bi bi-calendar-event",
          link: "/events",
          submenu: false,
          showSubRoute: false,
        },
        {
          permission: permissions.settings,
          label: "Ayarlar",
          icon: "bi bi-gear",
          link: "/settings/general/attributes",
          // submenu: true,
          showSubRoute: false,
          // submenuItems: [
          //   {
          //     permission: true,
          //     label: "Genel Ayarlar",
          //     link: "/settings/general/attributes",
          //     showSubRoute: false,
          //   },
          //   {
          //     permission: true,
          //     label: "İçerik Ayarları",
          //     link: "/settings/content/president",
          //     showSubRoute: false,
          //   },
          // ],
        },
        {
          permission: true,
          label: "Dil Yönetimi",
          icon: "bi bi-translate",
          link: "/translations",
          submenu: false,
          showSubRoute: false,
        },
      ],
    },

    // ---- Product Menü Start ----
    {
      permission: permissions.product || permissions.offer,
      label: "Site Yönetimi",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          permission: permissions.announce,
          label: "Duyurular",
          icon: "bi bi-broadcast",
          link: "/announce",
          submenu: false,
          showSubRoute: false,
        },
        {
          permission: true,
          label: "Haberler",
          icon: "bi bi-newspaper",
          link: "/news",
          submenu: false,
          showSubRoute: false,
        },
        // {
        //   permission: permissions.product,
        //   label: "Ürün Tanımlamaları",
        //   icon: "ti ti-brand-airtable",
        //   submenu: true,
        //   showSubRoute: false,
        //   submenuItems: [
        //     {
        //       permission: true,
        //       label: "Ürün Kategorileri",
        //       link: "/product-categories",
        //       showSubRoute: false,
        //     },
        //     {
        //       permission: true,
        //       label: "Takımlar",
        //       link: "/product-teams",
        //       showSubRoute: false,
        //     },
        //     {
        //       permission: true,
        //       label: "Tedariçiler",
        //       link: "/suppliers",
        //       showSubRoute: false,
        //     },
        //   ],
        // },
      ],
    },
    // ---- Product Menü End ----

    {
      permission: permissions.admin || permissions.role,
      label: "Panel Kullanıcı Yönetimi",
      submenuOpen: true,
      submenuHdr: "Sales",
      submenu: false,
      showSubRoute: false,
      submenuItems: [
        {
          permission: permissions.admin,
          label: "Kullanıcılar",
          link: "/admins",
          icon: "ti ti-file-invoice",
          showSubRoute: false,
          submenu: false,
        },
        {
          permission: permissions.role,
          label: "Rol ve İzinler",
          link: "/roles",
          icon: "ti ti-navigation-cog",
          showSubRoute: false,
          submenu: false,
        },
      ],
    },
    // ---- User Menü End ----

    // ---- Mail Menü Start ----
    // {
    //   permission: permissions.user || permissions.role,
    //   label: "E-Posta",
    //   submenuOpen: true,
    //   submenuHdr: "Sales",
    //   submenu: false,
    //   showSubRoute: false,
    //   submenuItems: [
    //     {
    //       permission: permissions.user,
    //       label: "Şablonlar",
    //       link: "/email/templates",
    //       icon: "ti ti-mail",
    //       showSubRoute: false,
    //       submenu: false,
    //     },
    //   ],
    // },
    // {
    //   permission: false,
    //   label: "Diğer",
    //   submenuOpen: true,
    //   submenuHdr: "Sales",
    //   submenu: false,
    //   showSubRoute: false,
    //   submenuItems: [
    //     {
    //       permission: true,
    //       label: "Aktiviteler",
    //       link: "/activities",
    //       icon: "ti ti-activity-heartbeat",
    //       showSubRoute: false,
    //       submenu: false,
    //     },
    //   ],
    // },
    // ---- User Menü End ----

    // ---- Settings Menü Start ----
    {
      permission: false,
      // permission:
      //   permissions.settings ||
      //   permissions.com_settings ||
      //   permissions.bank_account ||
      //   permissions.exchange,
      label: "Ayarlar",
      submenuOpen: true,
      submenuHdr: "Sales",
      submenu: false,
      showSubRoute: false,
      submenuItems: [
        {
          permission: permissions.settings || permissions.comp_settings,
          label: "Genel Ayarlar",
          icon: "ti ti-brand-airtable",
          submenu: true,
          showSubRoute: true,
          submenuItems: [
            {
              permission: permissions.comp_settings,
              label: "Şirket Ayarları",
              link: "/settings/general/company",
              showSubRoute: false,
            },
            {
              permission: permissions.comp_settings,
              label: "Sosyal Medyalar",
              link: "/settings/general/socials",
              showSubRoute: false,
            },
            {
              permission: permissions.comp_settings,
              label: "Web Siteleri",
              link: "/settings/general/websites",
              showSubRoute: false,
            },
            {
              permission: permissions.comp_settings,
              label: "Kullanılan Diller",
              link: "/settings/general/languages",
              showSubRoute: false,
            },
            {
              permission: permissions.settings,
              label: "Tema Ayarları",
              link: "/settings/general/theme",
              showSubRoute: false,
            },
          ],
        },
        // {
        //   permission: permissions.settings,
        //   label: "İçerik Ayarları",
        //   icon: "ti ti-brand-airtable",
        //   submenu: true,
        //   showSubRoute: true,
        //   submenuItems: [
        //     {
        //       permission: permissions.bank_account,
        //       label: "Banka Hesapları",
        //       link: "/settings/finance/bank-accounts",
        //       showSubRoute: false,
        //     },
        //     {
        //       permission: permissions.settings,
        //       label: "Prim Ayarları",
        //       link: "/settings/finance/prim",
        //       showSubRoute: false,
        //     },
        //     {
        //       permission: permissions.exchange,
        //       label: "Kur Ayarları",
        //       link: "/settings/finance/exchange-rates",
        //       showSubRoute: false,
        //     },
        //   ],
        // },
        {
          permission:
            permissions.bank_account ||
            permissions.exchange ||
            permissions.settings,
          label: "Sistem Ayarları",
          icon: "ti ti-device-laptop",
          submenu: true,
          showSubRoute: true,
          submenuItems: [
            {
              permission: permissions.settings,
              label: "E-Posta Ayarları",
              link: "/settings/system/email",
              showSubRoute: false,
            },
            {
              permission: permissions.settings,
              label: "Sms Ayarları",
              link: "/settings/system/sms",
              showSubRoute: false,
            },
          ],
        },
      ],
    },
    // ---- Settings Menü End ----
  ];

  return items;
}
